import React from "react";

// Renders the "DHADDA MOTION PICTURES" brand name in the same bold,
// condensed uppercase font used in the official gold logo.
export const BrandName = ({ className = "", short = false }) => (
  <span
    className={`brand-name ${className}`}
    style={{ display: "inline" }}
    data-testid="brand-name"
  >
    {short ? "Dhadda" : "Dhadda Motion Pictures"}
  </span>
);

export default BrandName;
